import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowLeft, 
  faAnchor,
  faRulerHorizontal,
  faUsers,
  faBed,
  faToilet
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/boat/BackToListingButton.css';

const BackToListingButton = ({ boat }) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Thresholds for showing/hiding
    const topThreshold = 150; // Hide when within 150px of top
    const bottomThreshold = 150; // Hide when within 150px of bottom
    
    const isAtTop = currentScrollY <= topThreshold;
    const isAtBottom = currentScrollY + windowHeight >= documentHeight - bottomThreshold;
    
    // Show only when scrolling and not at top/bottom
    if (!isAtTop && !isAtBottom) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  useEffect(() => {
    // Add scroll listener with passive option for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const scrollToBooking = () => {
    const bookingForm = document.querySelector('.boat-details-two-col-section__right');
    if (bookingForm) {
      bookingForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const displayPrice = boat.discount_price || boat.price;

  const renderSpec = (icon, value, unit = '') => {
    if (!value && value !== 0) return null;
    return (
      <span><FontAwesomeIcon icon={icon} /> {value}{unit}</span>
    );
  };

  return (
    <div className={`navigation-bar ${isVisible ? 'navigation-bar--visible' : ''}`}>
      <div className="navigation-bar__content">
        <button
          className="back-section"
          onClick={() => {
            if (location.state && location.state.from) {
              navigate(location.state.from.pathname + location.state.from.search);
            } else {
              navigate('/');
            }
          }}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <div className="back-arrow">
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <div className="back-section__content">
            <span className="back-section__label">You're viewing:</span>
            <span className="back-section__boat-name">{boat.name}</span>
            <span className="back-section__return">Back to boat listings</span>
          </div>
        </button>

        <div className="boat-info">
          <div className="boat-specs">
            {renderSpec(faRulerHorizontal, boat.length, 'ft')}
            {renderSpec(faUsers, boat.capacity)}
            {renderSpec(faBed, boat.staterooms)}
            {renderSpec(faToilet, boat.bathrooms)}
          </div>
          {displayPrice && (
            <div className="price-section">
              <span className="price-label">FROM</span>
              <span className="price-amount">${displayPrice}</span>
            </div>
          )}
          <button onClick={scrollToBooking} className="book-now-button">
            <FontAwesomeIcon icon={faAnchor} />
            <span>Book Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackToListingButton; 